import { defineMessages } from "react-intl";
export default defineMessages({
    whatsNew: {
        id: "aiDiscoverability.appSidebar.whatsNew",
        defaultMessage: "What's New",
    },
    whatsNewWithUnread: {
        id: "aiDiscoverability.appSidebar.whatsNewWithUnread",
        defaultMessage: "What's New, {count, plural, one {# unread announcement} other {# unread announcements}}",
    },
});
